import { groupBy, orderBy } from "lodash";
import { Item__Atividades, ItemPropriedades } from "../../../../../../../services/atividades/GET";
import { typeInsumos, typeEstruturaTodasAtvs, normalizarQuantidadeRelatorio } from "../../atvsTodas/meta/estrutura_todas_atvs";
import { estruturaPlanejamentoInsumos } from "../../planejamentoInsumos/meta";
import { obterCodInsumo } from "../../../../linhaDoTempo/components/cadastro/components/executada/components/execucoesTable/meta";
import { typeInsumoAdd } from "../../../../linhaDoTempo/components/cadastro";
import { normarlizarEmKg, obterNomeMediaLocal } from "../../../../visaoGeral/components/insumosPrecisao/meta";
import { normarlizarEmLitros } from "../../../../visaoGeral/components/insumosLiquidosPrecisao/meta";


export type typeComprativoInsumos = {
    cod_insumo: number,
    insumo_nome: string,
    tipo_fisico: string,
    tipo_nome: string,
    cod_tipo: number,
    medida: string,
    quantidade_planejada: number,
    quantidade_executada: number,
    precisao: number,
    porcentagem: number
}

export type typeInsumosPorTalhao = {
    cod_talhao: number;
    nome_talhao: string;
    area: number;
    lista_insumos: typeComprativoInsumos[];
}

export type typeEstruturaComparativoInsumos = {
    cod_propriedade: number;
    nome_propriedade: string;
    lista_insumos_por_talhao: typeInsumosPorTalhao[];
};


export function estruturaComparativoInsumos(
    data_atividades: Item__Atividades[],
    data_propriedades: ItemPropriedades[],
    cod_propriedade_selecionada: number,
    cod_talhao_selecionado: number,
    cod_subarea_selecionada: number,
): typeEstruturaComparativoInsumos[] {

    const atividades_executadas = (data_atividades ?? []).filter(i => i.cod_tipo === 2 && i.delete_time === null);

    //@ts-ignore
    const apenas_insumos_executados = atividades_executadas.flatMap(atividade =>
        (atividade.andamentos ?? []).flatMap(andamento =>
            (andamento.insumos ?? []).map(insumo => {
                const tipo_fisico = obterNomeMediaLocal(insumo?.cod_medida).tipo_fisico;
                const { quantidade, medida } = normalizarQuantidadeRelatorio(Number(insumo.quantidade), insumo?.cod_medida);
                return {
                    ...insumo,
                    cod_talhao: atividade.cod_talhao,
                    cod_atividade: atividade.cod,
                    cod_atividade_planejada: atividade.cod_atividade,
                    cod_insumo: obterCodInsumo(insumo as unknown as typeInsumoAdd),
                    quantidade_normalizada: quantidade,
                    nome_medida_normalizada: medida,
                    tipo_fisico: tipo_fisico,
                }
            })
        )
    );

    const apenas_insumos_executados_por_talhao = groupBy(apenas_insumos_executados, 'cod_talhao');

    const dicionario_insumos_executados: Record<string, number> = {};
    apenas_insumos_executados.forEach(insumo => {
        const key = `${insumo.cod_talhao}_${insumo.cod_insumo}_${insumo.tipo_fisico}`;
        if (!dicionario_insumos_executados[key]) dicionario_insumos_executados[key] = 0;
        dicionario_insumos_executados[key] += Number(insumo.quantidade_normalizada || 0);
    });

    function obterQtdInsumoExecutado(cod_talhao: number, cod_insumo: number, tipo_fisico: string) {
        const key = `${cod_talhao}_${cod_insumo}_${tipo_fisico}`;
        const somar_insumos_executados = dicionario_insumos_executados[key] || 0;
        return Number(somar_insumos_executados.toFixed(2));
    }

    function obterInsumosSemPlanejamento(cod_talhao: number, cods_insumos_planejados: number[]) {
        const set_cods_insumos_planejados = new Set(cods_insumos_planejados);
        const insumos_talhao = apenas_insumos_executados_por_talhao[cod_talhao] || [];

        const insumos_sem_planejamento = insumos_talhao.filter(i => !set_cods_insumos_planejados.has(i.cod_insumo)).map(i => ({ ...i, key: `${i.cod_insumo}_${i.tipo_fisico}` }));
        const agrupar_insumos_sem_planejamento = groupBy(insumos_sem_planejamento, 'key');

        const somar_insumos_sem_planejamento = Object.entries(agrupar_insumos_sem_planejamento ?? []).map(([_key, lista_insumos_sem_planejamento]) => {
            const item = lista_insumos_sem_planejamento[0];
            const quantidade_executada = (lista_insumos_sem_planejamento ?? []).reduce((acc, item) => acc + Number(item.quantidade_normalizada), 0);
            return {
                cod_insumo: item.cod_insumo,
                insumo_nome: item.insumo_nome,
                cod_talhao: item.cod_talhao,
                tipo_fisico: item.tipo_fisico,
                tipo_nome: item.tipo_nome,
                cod_tipo: item.cod_tipo,
                medida: item?.nome_medida_normalizada,
                quantidade_planejada: 0,
                quantidade_executada: Number(quantidade_executada?.toFixed(2)),
            }
        });

        return somar_insumos_sem_planejamento ?? [];
    }

    function obterQtdInsumoPlanejado(lista_insumos: typeInsumos[], cod_talhao: number) {

        const lista_insumos_com_key = (lista_insumos ?? []).map(insumo => ({ ...insumo, key: `${insumo.cod_insumo}_____${insumo.tipo_fisico}` }));

        const agrupar_insumos_planejados = groupBy(lista_insumos_com_key, 'key');

        const somar_insumos_planejados = Object.entries(agrupar_insumos_planejados ?? []).map(([_key, lista_insumos_por_insumo]) => {
            const item = lista_insumos_por_insumo[0];
            const quantidade_planejada = (lista_insumos_por_insumo ?? []).reduce((acc, item) => acc + Number(item.quantidade_insumo_normalizada), 0);
            return {
                cod_insumo: item.cod_insumo,
                insumo_nome: item.insumo_nome,
                cod_talhao: item.cod_talhao,
                tipo_fisico: item.tipo_fisico,
                tipo_nome: item.tipo_nome,
                cod_tipo: item.cod_tipo,
                medida: item?.medida_insumo_normalizada,
                quantidade_planejada: Number(quantidade_planejada?.toFixed(2)),
                quantidade_executada: obterQtdInsumoExecutado(cod_talhao, item.cod_insumo, item.tipo_fisico),
            }
        });

        const cods_insumos_planejados = somar_insumos_planejados.map(i => i.cod_insumo);

        const insumos_exec_sem_planejamento = obterInsumosSemPlanejamento(cod_talhao, cods_insumos_planejados);

        const insumos_planejados_e_executados = [...somar_insumos_planejados, ...insumos_exec_sem_planejamento];

        return orderBy(insumos_planejados_e_executados, ['tipo_nome', 'insumo_nome', 'tipo_fisico'], ['asc', 'asc', 'asc']);
    }

    const insumos_planejados = estruturaPlanejamentoInsumos(data_atividades, data_propriedades, cod_propriedade_selecionada, cod_talhao_selecionado, cod_subarea_selecionada);

    const insumos_com_precisao = (insumos_planejados ?? []).map(propriedades => ({
        ...propriedades,
        lista_insumos_por_talhao: (propriedades?.lista_insumos_por_talhao ?? []).map(talhao => {

            const insumos_totalizados_talhao = obterQtdInsumoPlanejado(talhao.lista_insumos, talhao.cod_talhao);

            return {
                ...talhao,
                lista_insumos: insumos_totalizados_talhao.map(insumo => {

                    let precisao = 0;
                    let porcentagem = 0;

                    if (insumo?.quantidade_planejada > 0) {
                        const porcentagem_realizada = (insumo?.quantidade_executada / insumo?.quantidade_planejada) * 100;

                        precisao = 100 - Math.abs(100 - porcentagem_realizada);
                        if (precisao < 0) precisao = 0;

                        porcentagem = porcentagem_realizada;

                    } else if (insumo?.quantidade_executada > 0) {
                        precisao = 0;
                        porcentagem = 0;
                    }

                    return {
                        ...insumo,
                        precisao: Number(precisao?.toFixed(2)),
                        porcentagem: Number(porcentagem?.toFixed(2))
                    }
                })
            }
        })
    }))

    // console.log("insumos_planejados: ", insumos_planejados);
    console.log("insumos_com_precisao: ", insumos_com_precisao);

    return insumos_com_precisao ?? [];
};

// export function normalizarQuantidadeRelatorio(tipo_fisico: string, cod_medida: number, quantidade: number) {

//     const tipo_fisico_lower = String(tipo_fisico)?.toLowerCase()

//     if (tipo_fisico_lower == 'líquido') {
//         return { qtd: normarlizarEmLitros(quantidade, cod_medida), nome_medida_normalizada: 'L' };
//     }
//     if (tipo_fisico_lower == 'sólido') {
//         return { qtd: normarlizarEmKg(quantidade, cod_medida), nome_medida_normalizada: 'kg' };
//     }
//     if (tipo_fisico_lower == 'sementes') {
//         return { qtd: quantidade, nome_medida_normalizada: 'Sementes' };
//     }

//     return { qtd: quantidade, nome_medida_normalizada: '?' };
// }